module.exports = __webpack_public_path__ + "static/profile-pic-6205e5faa77a66de171ebcd9971e7c0b.jpg";